export enum PaymentDeposit {
    NO = 1,
    PERCENTAGE_OF_THE_RENT = 2,
    FIXED_PRICE = 3,
}
